import { external } from './environment.common'
import {
  production,
} from './environment.production'

export const environment = {
  ...production,
  ...external,
}
